import {
  APIResponseType,
  createDeleteApiHook,
  createGetApiHook,
  createPatchApiHook,
  createPostApiHook,
} from "@/shared";
import { CardCollectedDeck, CardCollectedDeckQueryParams } from "../types/card-collected-deck.type";

/**
 * GET `/user-deck` — Saved / Collected cards.
 * Each item has `main_card.content` (cover) and `main_card.table_of_contents`.
 */
const getCharmCardsAPI = (queryParams: CardCollectedDeckQueryParams = {}): string => {
  const { headers: _headers, ...rest } = queryParams;
  const fullParams = {
    ...rest,
    offset: rest.offset ?? 0,
    limit: rest.limit ?? 1000,
  };

  const queryString = new URLSearchParams(fullParams).toString();
  return queryString ? `/user-deck?${queryString}` : `/user-deck`;
};

export const useGetCharmCards = createGetApiHook<
  APIResponseType<CardCollectedDeck[]>,
  {
    type: "Saved" | "Collected";
    headers?: Record<string, string>;
  } & CardCollectedDeckQueryParams
>(getCharmCardsAPI);

const addCardToCharmCardsAPI = () => {
  return "/user-deck";
};

export const useAddCardToCharmCards = createPostApiHook<
  {},
  {
    headers?: Record<string, string>;
  },
  APIResponseType<CardCollectedDeck>
>(addCardToCharmCardsAPI, {
  isFormDataMethod: false,
});

const removeCardFromCharmCardsAPI = ({ main_card_id }: { main_card_id: number }) => {
  return `/user-deck/${main_card_id}`;
};

export const useRemoveCardFromCharmCards = createDeleteApiHook<
  {},
  { main_card_id: number; headers?: Record<string, string> },
  APIResponseType<unknown>
>(removeCardFromCharmCardsAPI, {
  isFormDataMethod: false,
});

const getUpdateCountOfCharmCardsAPI = () => {
  return "/user-deck/updates/count";
};

export const useGetUpdateCountOfCharmCards = createGetApiHook<
  APIResponseType<{ count: number }>,
  { headers?: Record<string, string> }
>(getUpdateCountOfCharmCardsAPI);

const changeStatustoSeenOfCharmCardsAPI = ({ main_card_id }: { main_card_id: number }) => {
  return `/user-deck/seen/${main_card_id}`;
};

export const useChangeStatustoSeenOfCharmCards = createPatchApiHook<
  {},
  { main_card_id: number; headers?: Record<string, string> },
  APIResponseType<unknown>
>(changeStatustoSeenOfCharmCardsAPI, {
  isFormDataMethod: false,
});
